import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServersSessionsService {
  _http = inject(HttpClient);
  private document = inject(DOCUMENT);

  getUrlSessions():Observable<string> {

    return this._http.get<string>( environment.url + '/api/sessionLegado');
  }

  redirectExternal(url_redirect?: string) {

    this.getUrlSessions().subscribe({
      next: (res: any) => {
        
        let dominio = this.document.location.origin;

        if (url_redirect) {
          
          let base64Url = btoa(dominio + url_redirect);
          window.location.href = res.URL + "&redir=" + base64Url;
        }else{

          window.location.href = res.URL;
        }
      },
      error: (error) => {

        console.log(error);
      }
    })
  }
}
